import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import LockStatsMain from '../../../../components/stats/LockStatsMain'

import { stats as ROLES_CONFIG } from '../../../../config/roles';


export default class LockStats extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.lockHistoryStats.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 ml-3-2vw h-100 mt-1vw p-0 mb-1vw customShadow" zDepth={3}>
                <LockStatsMain />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./routes/app/routes/stats/LockStats.js